import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ApiUrl } from "../../Constants/Weburl";
import "../../CssPage/Livesettings.css";
import SettingSidebar from "../../components/Setttingsidebar";
import CustomContainer from "../../components/Customsettingscontain";
import Customsettingscard from '../../components/Customsettingscard';
import { Row, Col } from 'react-bootstrap';
import CustomInput from "../../components/Custominput";
import CustomCard from "../../components/Customsettingscard";
import CustomButton from "../../components/CustomButton";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";
import { toast } from "react-toastify";


export default function Limit() {
    const [limits, setLimits] = useState({
        maxpostperday: "",
        maxstoriesperday: "",
        maxcommentsperday: "",
        maxcommentreplyperday: "",
        maxcommentpins: "",
        maximagesperpost: "",
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const adminToken = localStorage.getItem("adminToken");

    console.log('adminToken', adminToken);

    useEffect(() => {
        const fetchLimits = async () => {
            try {
                const res = await axios.get(`${ApiUrl}api/getlimits`, {

                    headers: { Authorization: `Bearer ${adminToken}` }

                });
                const d = res.data?.data || {};
                setLimits({
                    maxpostperday: d.maxpostperday ?? "",
                    maxstoriesperday: d.maxstoriesperday ?? "",
                    maxcommentsperday: d.maxcommentsperday ?? "",
                    maxcommentreplyperday: d.maxcommentreplyperday ?? "",
                    maxcommentpins: d.maxcommentpins ?? "",
                    maximagesperpost: d.maximagesperpost ?? "",
                });

            } catch (err) {
                toast.error("Failed to load limits");
            } finally {
                setLoading(false);
            }
        };
        fetchLimits();
    }, []);

    // Ovvoru input-kum value + onChange
    const bind = (key) => ({
        value: limits[key],
        onChange: (e) => setLimits((prev) => ({ ...prev, [key]: e.target.value })),
    });

    const saveSettings = async () => {
        const hasInvalid = Object.values(limits).some(
            (v) => v === "" || Number(v) < 1
        );
        if (hasInvalid) {
            toast.error("All limits must be 1 or more");
            return;
        }

        try {
            setSaving(true);
            await axios.put(`${ApiUrl}api/savelimits`, limits,
                {

                    headers: { Authorization: `Bearer ${adminToken}` }

                });
            toast.success("Limits saved");
        } catch (err) {
            toast.error(err?.response?.data?.message || "Failed to save limits");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Layout>
            <SettingsPageShell wrapperClassName="rr-wrapper-live">
                {loading ? (
                    <div className="ls-wrapper">
                        <p>Loading...</p>
                    </div>
                ) : (
                    <div className="ls-wrapper">
                        <div className="ls-section-title">LIMIT</div>

                        <div className="ls-grid-3">
                            <CustomCard className="ls-card">
                                <CustomInput
                                    label="Max. Post Upload/Day"
                                    labelClassName="ls-label"
                                    type="number"
                                    className="ls-input"
                                    {...bind("maxpostperday")}
                                />
                            </CustomCard>

                            <CustomCard className="ls-card">
                                <CustomInput
                                    label="Max. Stories/Day"
                                    labelClassName="ls-label"
                                    type="number"
                                    className="ls-input"
                                    {...bind("maxstoriesperday")}
                                />
                            </CustomCard>

                            <CustomCard className="ls-card">
                                <CustomInput
                                    label="Max. Comments/Day"
                                    labelClassName="ls-label"
                                    type="number"
                                    className="ls-input"
                                    {...bind("maxcommentsperday")}
                                />
                            </CustomCard>

                            <CustomCard className="ls-card">
                                <CustomInput
                                    label="Max. Comment Reply/Day"
                                    labelClassName="ls-label"
                                    type="number"
                                    className="ls-input"
                                    {...bind("maxcommentreplyperday")}
                                />
                            </CustomCard>

                            <CustomCard className="ls-card">
                                <CustomInput
                                    label="Max. Comment Pins"
                                    labelClassName="ls-label"
                                    type="number"
                                    className="ls-input"
                                    {...bind("maxcommentpins")}
                                />
                            </CustomCard>

                            <CustomCard className="ls-card">
                                <CustomInput
                                    label="Max. Images Per Post"
                                    labelClassName="ls-label"
                                    type="number"
                                    className="ls-input"
                                    {...bind("maximagesperpost")}
                                />
                            </CustomCard>
                        </div>

                        <CustomButton
                            className="ls-save-btn"
                            onClick={saveSettings}
                            disabled={saving}
                        >
                            {saving ? "Saving..." : "Save"}
                        </CustomButton>
                    </div>
                )}
            </SettingsPageShell>
        </Layout>
    );
}


